/**
 * @name audio-lines-off
 * @description Lucide SVG string.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMTAgMTB2MTEiIC8+CiAgPHBhdGggZD0iTTEwIDN2MS4zNSIgLz4KICA8cGF0aCBkPSJNMTQgMTR2MSIgLz4KICA8cGF0aCBkPSJNMTQgOHYuMzUiIC8+CiAgPHBhdGggZD0iTTE4IDV2Ny4zNSIgLz4KICA8cGF0aCBkPSJNMiAxMHYzIiAvPgogIDxwYXRoIGQ9Im0yIDIgMjAgMjAiIC8+CiAgPHBhdGggZD0iTTIyIDEwdjMiIC8+CiAgPHBhdGggZD0iTTYgNnYxMSIgLz4KPC9zdmc+Cg==) - https://lucide.dev/icons/audio-lines-off
 * @see https://lucide.dev/guide/packages/lucide-static - Documentation
 *
 * @returns {String}
 *
 */
const AudioLinesOff: string = `
<svg
  class="lucide lucide-audio-lines-off"
  xmlns="http://www.w3.org/2000/svg"
  width="24"
  height="24"
  viewBox="0 0 24 24"
  fill="none"
  stroke="currentColor"
  stroke-width="2"
  stroke-linecap="round"
  stroke-linejoin="round"
>
  <path d="M10 10v11" />
  <path d="M10 3v1.35" />
  <path d="M14 14v1" />
  <path d="M14 8v.35" />
  <path d="M18 5v7.35" />
  <path d="M2 10v3" />
  <path d="m2 2 20 20" />
  <path d="M22 10v3" />
  <path d="M6 6v11" />
</svg>
`;

export default AudioLinesOff;
